/**
 * Australian account type display labels (Region Pack)
 */

import { AccountType } from '../../../../types/account.types';

const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  [AccountType.BANK_CASH]: 'Transaction Account',
  [AccountType.SAVINGS]: 'Savings Account',
  [AccountType.CREDIT_CARD]: 'Credit Card',
  [AccountType.LOAN]: 'Loan Account',
  [AccountType.INVESTMENTS_SUPERANNUATION]: 'Investment / Superannuation',
  [AccountType.ASSETS]: 'Asset Account',
};

export function getAccountTypeLabel(type: AccountType | string): string {
  return ACCOUNT_TYPE_LABELS[type as AccountType] ?? String(type);
}
